import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';

const AboutUsPage = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    agreeTerms: false,
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle form submission - UPDATED TO SEND DATA TO BACKEND
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.agreeTerms) {
      alert('You must agree to the Terms & Conditions.');
      return;
    }
    if (!formData.message.trim()) {
      alert('Please leave a message.');
      return;
    }

    try {
      // Send a POST request to your Node.js backend
      // NEW CODE:
      const response = await fetch('https://friends-techbd.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        alert('Message sent successfully!');
        // Reset form
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
          agreeTerms: false,
        });
      } else {
        alert(`Failed to send: ${result.message}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while sending your message. Please try again later.');
    }
  };

  return (
    <>
      {/* Top Heading Section */}
      <div className="text-center py-5">
        <p className="text-muted text-uppercase mb-2" style={{letterSpacing: '2px', fontSize: '0.8rem'}}>— Contact —</p>
        <h1 className="display-4 font-weight-bold mb-3">Feel Free Contact Us Today And</h1>
        <h1 className="display-4 font-weight-bold mb-5">Get Your Solution</h1>
        <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
          You can talk to our online representative at any time. With every project we undertake, we
          set the bar high and provide the best people in the industry, with a true love of what we do
          to make our Customers' vision a reality.
        </p>
      </div>

      {/* Main Contact Section: Form and Info Cards */}
      <Container className="my-5">
        <Row>
          {/* Left Column: Contact Form */}
          <Col md={7} className="mb-4">
            <Card className="shadow-sm border-0 h-100 p-4">
              <Card.Body>
                <h3 className="mb-4 font-weight-bold">Get in Touch</h3>
                <p className="text-muted mb-4">
                  Give us a call or drop by anytime, we endeavour to answer all enquiries within 24 hours.
                </p>
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="text"
                          placeholder="Your Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="bg-light border-0 py-2" 
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formEmail">
                        <Form.Control
                          type="email"
                          placeholder="Your Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="bg-light border-0 py-2"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId="formSubject" className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="bg-light border-0 py-2"
                    />
                  </Form.Group>
                  <Form.Group controlId="formMessage" className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Your Message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="bg-light border-0 py-2"
                    />
                  </Form.Group>
                  <Form.Group controlId="formTerms" className="mb-4">
                    <Form.Check
                      type="checkbox"
                      label="I agree to the Terms & Conditions"
                      name="agreeTerms"
                      checked={formData.agreeTerms}
                      onChange={handleChange}
                      required
                      feedback="You must agree before submitting."
                      feedbackType="invalid"
                    />
                  </Form.Group>
                  <Button variant="danger" type="submit" className="w-auto px-5 py-2">
                    SEND MESSAGE
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Column: Contact Information Cards */}
          <Col md={5}>
            <Row>
              {/* Call Us Card */}
              <Col xs={12} className="mb-4">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="d-flex align-items-center">
                    <div className="p-3 bg-danger text-white rounded-circle mr-3" style={{ fontSize: '1.5rem' }}>
                      📞
                    </div>
                    <div>
                      <h5 className="mb-1">Call Us:</h5>
                      <p className="mb-0">+880 1912294909</p>
                      <p className="mb-0">+880 1738666969</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Email Us Card */}
              <Col xs={12} className="mb-4">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="d-flex align-items-center">
                    <div className="p-3 bg-danger text-white rounded-circle mr-3" style={{ fontSize: '1.5rem' }}>
                      ✉️
                    </div>
                    <div>
                      <h5 className="mb-1">Email Us:</h5>
                      <p className="mb-0">friendstech.bd22@gmail.com</p>
                      <p className="mb-0">office@friendsbdtech.com</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Corporate Office Card */}
              <Col xs={12} className="mb-4">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="d-flex align-items-center">
                    <div className="p-3 bg-danger text-white rounded-circle mr-3" style={{ fontSize: '1.5rem' }}>
                      🏢
                    </div>
                    <div>
                      <h5 className="mb-1">Corporate Office:</h5>
                      <p className="mb-0">162/2 (1st Floor-A),</p>
                      <p className="mb-0">South Mugda-1214,</p>
                      <p className="mb-0">Dhaka, Bangladesh</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Google Maps Section */}
      <Container fluid className="mb-5">
        <div className="map-responsive" style={{ height: '450px' }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.83549727715!2d90.395786514983!3d23.84365778453488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c6b9d62f026f%3A0xc47b9b009f4a0c20!2sPriyanka%20Runway%20City!5e0!3m2!1sen!2sbd!4v1678893456789!5m2!1sen!2sbd" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </div>
      </Container>
    </>
  );
};

export default AboutUsPage;